export const roleIsClient = role => ['ROLE_CLIENT', 'ROLE_CLIENT_MASTER', 'ROLE_POS_OWNER'].includes(role);
export const roleIsPosOwner = role => ['ROLE_POS_OWNER'].includes(role);
export const roleIsService = role => ['ROLE_SERVICE', 'ROLE_SERVICE_MASTER'].includes(role);

export const roles = [
    { id: 'ROLE_CLIENT', name: 'Klient normalny' },
    { id: 'ROLE_CLIENT_MASTER', name: 'Klient master' },
    { id: 'ROLE_SERVICE', name: 'Serwis' },
    { id: 'ROLE_SERVICE_MASTER', name: 'Serwis master' },
    { id: 'ROLE_ADMIN', name: 'Admin' },
    { id: 'ROLE_BOK', name: 'BOK' },
    { id: 'ROLE_POS_OWNER', name: 'POS Owner' },
];

export const clientRoles = roles.filter(({ id }) => roleIsClient(id));
export const serviceRoles = roles.filter(({ id }) => roleIsService(id));
